module.exports = __webpack_public_path__ + "img/news_banner_1.de44ab48.jpg";